export const medicalConditions = [
  'Asthma', 'Diabetes', 'Hypertension', 'Hyperthyroidism', 'Hypothyroidism', 'Anemia',
  'Chronic Fatigue Syndrome', 'Obesity', 'Cancer', 'Stroke', 'Epilepsy', 'Multiple Sclerosis',
  'Parkinson’s Disease', 'Osteoarthritis', 'Rheumatoid Arthritis', 'Gout', 'Psoriasis',
  'Irritable Bowel Syndrome (IBS)', 'Celiac Disease', 'Lactose Intolerance',
  'Gastroesophageal Reflux Disease (GERD)', 'Peptic Ulcer Disease', 'Chronic Kidney Disease',
  'Liver Cirrhosis', 'Hepatitis B', 'Hepatitis C', 'Tuberculosis', 'HIV/AIDS',
  'Chronic Obstructive Pulmonary Disease (COPD)', 'Sleep Apnea', 'Insomnia',
  'Anxiety Disorder', 'Depression', 'Bipolar Disorder', 'Schizophrenia',
  'Attention Deficit Hyperactivity Disorder (ADHD)', 'Autism Spectrum Disorder',
  'Post-Traumatic Stress Disorder (PTSD)', 'Obsessive-Compulsive Disorder (OCD)',
];

export const operationDiagnosisOptions = [
    "Appendicitis", "Cholecystitis", "Hernia", "Fracture", "Pneumonia", "Diabetes", "Hypertension", "Asthma"
];

export const surgeryOptions = [
  'Appendectomy', 'Cholecystectomy', 'Coronary Artery Bypass Grafting (CABG)',
  'Hysterectomy', 'Mastectomy', 'Prostatectomy', 'Tonsillectomy', 'Laparotomy',
  'Laparoscopy', 'Cataract Surgery', 'Spinal Fusion', 'Hip Replacement',
  'Knee Replacement', 'Cesarean Section (C-Section)', 'Gallbladder Removal',
  'Hernia Repair', 'Aortic Aneurysm Repair', 'Kidney Transplant', 'Liver Transplant',
  'Heart Valve Replacement', 'Appendix Removal', 'Thyroidectomy', 'Lung Resection',
  'Pancreatectomy', 'Colostomy', 'Gastrectomy', 'Nephrectomy', 'Splenectomy',
  'Adrenalectomy', 'Cholecystostomy', 'Cystectomy', 'Oophorectomy', 'Orchiectomy',
  'Parotidectomy', 'Pneumonectomy', 'Salpingectomy', 'Tonsillectomy and Adenoidectomy',
  'Vasectomy', 'Whipple Procedure',
];

export const procedureOptions = [
    "Appendectomy", "Cataract Surgery", "Hernia Repair", "Cholecystectomy", "Laparoscopy", "C-section", "Knee Replacement", "Hip Replacement", "CABG", "Endoscopy"
];

export const Locations = [
  'Right Upper Arm', 'Left Upper Arm', 'Right Lower Leg', 'Left Lower Leg',
  'Right Thigh', 'Left Thigh', 'Right Flank', 'Left Flank',
  'Right Abdomen', 'Left Abdomen', 'Right Chest', 'Left Chest',
];

export const orNumbers = ['OR12345', 'OR12346', 'OR12347', 'OR12348', 'OR12349', 'OR12350'];

export const equipmentOptions = [
  'Head Rest', 'Sand Bag', 'Pillow', 'Axillary Roll', 'Shoulder Roll',
  'Eye Protection', 'Chest Roll', 'Sling', 'Boot', 'Stirrups', 'Leg Holder',
  'L Arm Padded, Tucked & Secured', 'R Arm Padded, Tucked & Secured',
];

export const packingTypes = [
  { label: 'Gauze' }, { label: 'Hydrocolloid' }, { label: 'Foam' },
  { label: 'Alginate' }, { label: 'Silver-impregnated' },
];

export const sizeOptions = [
  { label: 'Small' }, { label: 'Medium' }, { label: 'Large' }, { label: 'Extra Large' },
];

export const outputOptions = [
  { label: 'Minimal' }, { label: 'Moderate' }, { label: 'Heavy' },
];

export const siteOptions = [
  { label: 'Wound 1' }, { label: 'Wound 2' }, { label: 'Wound 3' }, { label: 'Wound 4' },
];

export const bloodUnitTypes = [
  "PRBC - O Negative", "PRBC - A Positive", "FFP - Group AB",
  "Platelets - Apheresis", "Cryoprecipitate", "Whole Blood",
  "Washed Red Cells", "Irradiated Blood",
];

export const patientConditionSuggestions = [
  "Stable – transferred to recovery room", "Stable with close monitoring",
  "Critical – shifted to ICU", "Unstable – resuscitation ongoing",
  "Hemodynamically stable", "Requires ventilator support",
  "Post-operative bleeding observed", "Condition deteriorating – critical care initiated",
  "Stable but drowsy – under observation", "Critical – under inotropic support",
];

export const specimenTypes = [
  "Tissue biopsy", "Blood sample", "Urine sample", "Sputum", "Bone marrow",
  "CSF (Cerebrospinal Fluid)", "Pleural fluid", "Ascitic fluid", "Wound swab",
  "Pus", "Surgical specimen", "Tumor mass", "Lymph node", "Synovial fluid",
];

export const transferDestinations = [
  "Recovery Room", "Surgical ICU (SICU)", "Medical ICU (MICU)",
  "Pediatric ICU (PICU)", "Neonatal ICU (NICU)", "High Dependency Unit (HDU)",
  "Post-Anesthesia Care Unit (PACU)", "General Ward", "Transferred to Home", "Not Applicable",
];

export const implantNameSuggestions = [
  "Hip prosthesis", "Knee implant", "Dental implant", "Pacemaker",
  "Cochlear implant", "Spinal fusion device", "Intraocular lens",
  "Breast implant", "Cardiac stent", "Vascular graft",
];

export const transfusionReasons = [
  "Severe anemia", "Post-surgical blood loss", "Hemorrhage", "Low hemoglobin",
  "Cancer treatment", "Bleeding disorder", "Platelet transfusion need",
  "Massive trauma", "Chronic kidney disease", "ICU requirement",
];

export const surgeonOptions = [
  "Dr. Sarah Johnson", "Dr. Michael Chen", "Dr. Emily Rodriguez",
  "Dr. David Kim", "Dr. Lisa Thompson", "Dr. James Wilson",
  "Dr. Maria Garcia", "Dr. Robert Anderson",
];

export const anesthetistOptions = [
  "Dr. Patricia Williams", "Dr. Ahmed Hassan", "Dr. Jennifer Lee",
  "Dr. Christopher Brown", "Dr. Priya Sharma", "Dr. Alexander Moore",
  "Dr. Sofia Gonzalez", "Dr. Benjamin Clark",
];

export const anestheticAssistantOptions = [
  "CRNA - Michelle Taylor", "CRNA - Daniel Rodriguez", "CRNA - Lisa Chang",
  "Anesthesia Tech - Kevin Murphy", "Anesthesia Tech - Sarah Johnson",
  "Anesthesia Assistant - Ryan Davis", "Anesthesia Assistant - Maria Lopez",
  "Perfusionist - Thomas Anderson",
];

export const assistantOptions = [
  "Nurse Jennifer Smith", "Nurse Carlos Martinez", "Nurse Amanda Brown",
  "Nurse Kevin Lee", "Surgical Tech - Mark Davis", "Surgical Tech - Rachel White",
  "Anesthesia Assistant - Tom Jackson", "Surgical Assistant - Diana Moore",
];

export const durationOptions = [
    "15 minutes", "30 minutes", "45 minutes", "1 hour", "1.5 hours", "2 hours", "2.5 hours", "3 hours", "More than 3 hours"
];

export const operationNoteSuggestions = [
    "Procedure completed without complications.", "Patient tolerated the procedure well.", "Hemostasis secured.", "No adverse events noted during surgery.",
];

export const findingsSuggestions = [
    "No significant abnormalities found.", "Tissue appeared healthy and viable.", "Signs of inflammation observed.", "No evidence of infection or necrosis.",
];
